import { render, staticRenderFns } from "./PrayerTimeCard.vue?vue&type=template&id=42dbe8c0&scoped=true&"
import script from "./PrayerTimeCard.vue?vue&type=script&lang=js&"
export * from "./PrayerTimeCard.vue?vue&type=script&lang=js&"
import style0 from "./PrayerTimeCard.vue?vue&type=style&index=0&id=42dbe8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbe8c0",
  null
  
)

export default component.exports